import { Box, Button, Flex, SimpleGrid } from "@chakra-ui/react";
import { Input } from "../../components/Form/Input";
import { useFormContext } from "react-hook-form";
import { Select } from "../../components/Form/Select";
import { formUsuarioEditar, formUsuarioNovo } from "../../schemas/usuario";
import { useMutationNovoUsuario } from "../../hooks/usuarios/mutationNovoUsuario";
import { useMutationEditarUsuario } from "../../hooks/usuarios/mutationEditarUsuario";

const status = [
  {value: "1", label: "Ativo"},
  {value: "0", label: "Bloqueado"},
];

const tiposUsuario = [
  { value: '1', label: 'Atendente' },
  { value: '5', label: 'Emissor' },
];

type Props = {
  mode?: 'create' | 'edit';
  usuarioId?: string;
};

export function Form({ mode = 'create', usuarioId }: Props){
  const {register, reset, handleSubmit} = useFormContext<formUsuarioNovo | formUsuarioEditar>()

  const mutationNovo = useMutationNovoUsuario()
  const mutationEditar = useMutationEditarUsuario(usuarioId)
  const isPending = mode === 'edit' ? mutationEditar.isPending : mutationNovo.isPending

  const onSubmit = async (data: formUsuarioNovo | formUsuarioEditar) => {
    if (mode === 'edit') {
      await mutationEditar.mutateAsync(data as formUsuarioEditar);
      return;
    }

    await mutationNovo.mutateAsync(data as formUsuarioNovo);
  }

  return (
    <Box>
      <SimpleGrid columns={2} gap={4}>
        <Input {...register('nome')} type="text" label="Nome" />
        <Input {...register('email')} type="email" label="E-mail" />
        <Input
          {...register('password')}
          type="text"
          label={mode === 'edit' ? 'Senha (preencha apenas para alterar)' : 'Senha'}
        />
        <Select {...register('status')}  label="Status" options={status}/>
        <Select
          {...register('tipo')}
          label="Tipo de Usuário"
          options={tiposUsuario}
        />
      </SimpleGrid>
      <Flex mt={8} gap={2}>
        <Button disabled={isPending} onClick={() => reset()} w={'8rem'} colorScheme="blue" borderRadius={'none'} size={'sm'}>CANCELAR</Button>
        <Button onClick={handleSubmit(onSubmit)} isLoading={isPending} w={'8rem'} colorScheme="blue" borderRadius={'none'} size={'sm'}>SALVAR</Button>
      </Flex>
    
    </Box>
  )
}
